import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    modules: {
        runtime: require("./runtime").default,
    },
    state: {
        search: {},
        region: null,
        ignoreList: [],
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/chrome/index.js